import styled from "styled-components"

const AttributionFooter = styled.footer`
font-size: 11px; 
width: 100%;
text-align: center;
position: fixed;
bottom: 1%;
`

const AttributionLink = styled.a`
color: hsl(150, 100%, 66%);
text-decoration: none;
&:hover{
    text-shadow: 0 0 #52ffa8;
}
&:active{
    text-shadow: 0 0 #52ffa8;
}
`

const Attribution = () => {
  return (
    <AttributionFooter>
    Challenge by <AttributionLink href={"https://www.frontendmentor.io?ref=challenge"} target={"_blank"}>Frontend Mentor</AttributionLink>
    <br /> 
    Coded by <AttributionLink href={"https://eghosaomuemu.netlify.app"} target={"_blank"} >Eghosa Omuemu</AttributionLink>
  </AttributionFooter>
  )
}

export default Attribution